import { render, staticRenderFns } from "./ImpersonatePrompt.vue?vue&type=template&id=0053eeb2&scoped=true&"
import script from "./ImpersonatePrompt.vue?vue&type=script&lang=js&"
export * from "./ImpersonatePrompt.vue?vue&type=script&lang=js&"
import style0 from "./ImpersonatePrompt.vue?vue&type=style&index=0&id=0053eeb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0053eeb2",
  null
  
)

export default component.exports